export const getOAuthErrorMessage = error => {
  const errorCodes = {
    '2009': `This provider doesn't support your site's currency`,
    '2401': 'Incorrect provider credentials',
    '2402': 'This payment provider is currently unavailable. Reload the page and try again. If the issue continues, we can help.',
    '2411': 'New account limit reached. You can only create 3 accounts per day. Try again tomorrow.',
    '2430': 'Choose a currency for this site to be able to connect a payment method.'
  };
  if (error instanceof Error) {
    const OauthErrorCode = {
      OAuthConnectFlowClosed: '29',
      OAuthConnectFlowGrantDeclined: '30'
    };
    switch (error.message) {
      case OauthErrorCode.OAuthConnectFlowGrantDeclined:
      case OauthErrorCode.OAuthConnectFlowClosed:
        return `Payment provider connection was cancelled.`;
      default:
        const errorCode = errorCodes[error.message] ?? error.message;
        return `Payment provider was not connected: ${errorCode}`;
    }
  }
  return `Payment provider was not connected: ${String(error)}.`;
};
//# sourceMappingURL=getOAuthErrorMessage.js.map